import IApplicationBaseVm from "./IApplicationBaseVm"
import IApplicationEventVm from "./IApplicationEventVm"
import ICitizenVm from "./ICitizenVm"
import ICommentVm from "./ICommentVm"
import ICompanyVm from "./ICompanyVm"
import IDriverLicenseVm from "./IDriverLicenseVm"
import IEducationalInstitutionVm from "./IEducationalInstitutionVm"
import IReceiptVm from "./IReceiptVm"
import ITeamVm from "./ITeamVm"
import IInvoiceVm from "./../home/Payment/IInvoiceVm"
import { ActorSubmittingApplicationType } from "./../enums/ActorSubmittingApplicationType"
import { ApplicationCardStatusType } from "./../enums/ApplicationCardStatusType"
import { ApplicationStatusType } from "./../enums/ApplicationStatusType"
import { ApplicationSubmitStatusType } from "./../enums/ApplicationSubmitStatusType"
import { EducationalCourseType } from "./../enums/EducationalCourseType"
import { ExaminationResultType } from "./../enums/ExaminationResultType"
import { PaymentType } from "./../enums/PaymentType"
import { CertificateProcessType } from "./../flags/CertificateProcessType"
import { CertificateType } from "./../flags/CertificateType"

import * as IApplicationBaseVmInstance from "./IApplicationBaseVm"
import * as ICitizenVmInstance from "./ICitizenVm"
import * as IDriverLicenseVmInstance from "./IDriverLicenseVm"
import * as ITeamVmInstance from "./ITeamVm"
import * as ICompanyVmInstance from "./ICompanyVm"
import * as IEducationalInstitutionVmInstance from "./IEducationalInstitutionVm"

export default interface IApplicationVm extends IApplicationBaseVm {
    certificateNumber: string
    status: ApplicationStatusType
    citizen: ICitizenVm
    certificateProcessType: CertificateProcessType
    createdDate: string
    updatedDate: string
    certificateType: CertificateType
    base64ProfileImage: string
    isProfileImageModified: boolean
    base64SignatureImage: string
    profileImageCardStatus: ApplicationCardStatusType
    expireDate: string
    expireDateForTemporaryCertificate: string
    applicationSubmittetByEducationalInstitutionDate: string
    applicationSubmittetByCitizenDate: string
    applicationSubmittetByCitizenStatus: ApplicationSubmitStatusType
    applicationSubmittetByEducationalInstitutionStatus: ApplicationSubmitStatusType
    actorSubmittingApplicationType: ActorSubmittingApplicationType
    applicationEvents: IApplicationEventVm[]
    driverLicense: IDriverLicenseVm
    selectedTeam: ITeamVm
    selectedPaymentType: PaymentType
    companyChosenForPayment: ICompanyVm
    educationalInstitution: IEducationalInstitutionVm
    isActive: boolean
    invoices: IInvoiceVm[]
    receipts: IReceiptVm[]
    comments: ICommentVm[]
    examinationResultType: ExaminationResultType
    examinationResultDate: string
    canApplicationBeReactivated: boolean
    chosenEducationalCourseType: EducationalCourseType
    hasPendingValidFromDate: boolean
    certificateValidFromDate: string
    previousCertificateExpireDate: string
}

export const empty = (enableIteration: boolean = true): IApplicationVm => {
	return {
		...IApplicationBaseVmInstance.empty(),
		certificateNumber: "",
		status: ApplicationStatusType.NotSet,
		citizen: ICitizenVmInstance.empty(),
		certificateProcessType: CertificateProcessType.NotSet,
		createdDate: "",
		updatedDate: "",
		certificateType: CertificateType.NotSet,
		base64ProfileImage: "",
		isProfileImageModified: false,
		base64SignatureImage: "",
		profileImageCardStatus: ApplicationCardStatusType.NotSet,
		expireDate: "",
		expireDateForTemporaryCertificate: "",
		applicationSubmittetByEducationalInstitutionDate: "",
		applicationSubmittetByCitizenDate: "",
		applicationSubmittetByCitizenStatus: ApplicationSubmitStatusType.NotSet,
		applicationSubmittetByEducationalInstitutionStatus: ApplicationSubmitStatusType.NotSet,
		actorSubmittingApplicationType: ActorSubmittingApplicationType.NotSet,
		applicationEvents: [] as IApplicationEventVm[],
		driverLicense: IDriverLicenseVmInstance.empty(),
		selectedTeam: ITeamVmInstance.empty(),
		selectedPaymentType: PaymentType.NotSet,
		companyChosenForPayment: ICompanyVmInstance.empty(),
		educationalInstitution: IEducationalInstitutionVmInstance.empty(),
		isActive: false,
		invoices: [] as IInvoiceVm[],
		receipts: [] as IReceiptVm[],
		comments: [] as ICommentVm[],
		examinationResultType: ExaminationResultType.NotSet,
		examinationResultDate: "",
		canApplicationBeReactivated: false,
		chosenEducationalCourseType: EducationalCourseType.NotSet,
		hasPendingValidFromDate: false,
		certificateValidFromDate: "",
		previousCertificateExpireDate: ""
	} as IApplicationVm
}